import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Select, MenuItem, withStyles, Switch } from '@material-ui/core';
import { blue } from '@material-ui/core/colors';
import * as actions from '~/store/actions';
import messagesToast from '~/validations/messagesNotifications';
import * as NuacomComponent from '~/components';
import * as ringTones from '~/assets/sounds';
import * as lib from '~/dependencies';
import { Container, BoxSelect, Row, Column } from './styles';

const BlueSwitch = withStyles({
  switchBase: {
    color: blue[300],
    '&$checked': {
      color: blue[500],
    },
    '&$checked + $track': {
      backgroundColor: blue[500],
    },
  },
  checked: {},
  track: {},
})(Switch);

export default function SelectRingTones() {
  // HOOKS
  const dispatch = useDispatch();
  const { t } = lib.useTranslation();

  // SELECTORS
  const systemRingTone = useSelector(state => state.system?.ringTone);
  const systemInternalRingTone = useSelector(
    state => state.system?.internalRingtone
  );
  const systemCallWaitingSound = useSelector(
    state => state.system?.callWaitingSound
  );
  const disableKeypadTone = useSelector(
    state => state.system?.disableKeypadTone
  );

  const userTones = ['default', 'classicvibes', 'beep', 'silence'];

  const ringTonesList = Object.values(ringTones).filter(filePath =>
    userTones.some(tone => filePath.includes(tone))
  );

  function changeRingTone(value) {
    dispatch(actions.changeRingTone(value, systemInternalRingTone));
    lib.ToastMessage('success', messagesToast().SYSTEM.ringTone.change.success);
  }

  function changeInternalRingTone(value) {
    dispatch(actions.changeRingTone(systemRingTone, value));
    lib.ToastMessage('success', messagesToast().SYSTEM.ringTone.change.success);
  }

  function normalize(str) {
    let fileName = '';

    switch (str) {
      case 'default':
        fileName = 'Morning Star';
        break;
      case 'classicvibes':
        fileName = 'Classic Vibes';
        break;
      case 'beep':
        fileName = 'Beep';
        break;
      case 'silence':
        fileName = 'Silence';
        break;
      default:
    }

    return fileName;
  }

  function handleCallWaitingSound() {
    dispatch(actions.setCallWaitingSound(!systemCallWaitingSound));
  }

  function handleKeypadTone() {
    dispatch(actions.setDisableKeypadTone(!disableKeypadTone));
  }

  return (
    <Container>
      <div className="title">
        <div />
        <span>
          {t('screens.configuration.components.selectRingTones.default')}
        </span>
        <div />
      </div>
      <BoxSelect>
        <Select
          className="inputSelect"
          value={systemRingTone}
          onChange={e => changeRingTone(e.target.value)}>
          {ringTonesList &&
            ringTonesList.map(e => {
              const fileName = e
                .split('/static/media/')
                .join('')
                .split('.')[0];

              return (
                <MenuItem key={fileName} value={fileName}>
                  {normalize(fileName)}
                </MenuItem>
              );
            })}
        </Select>
      </BoxSelect>
      <NuacomComponent.PlayTest type="default" />
      <div className="title">
        <div />
        <span>
          {t('screens.configuration.components.selectRingTones.internal')}
        </span>
        <div />
      </div>
      <BoxSelect>
        <Select
          className="inputSelect"
          value={systemInternalRingTone}
          onChange={e => changeInternalRingTone(e.target.value)}>
          {ringTonesList &&
            ringTonesList.map(e => {
              const fileName = e
                .split('/static/media/')
                .join('')
                .split('.')[0];

              return (
                <MenuItem key={fileName} value={fileName}>
                  {normalize(fileName)}
                </MenuItem>
              );
            })}
        </Select>
      </BoxSelect>
      <NuacomComponent.PlayTest type="internal" />
      <Row>
        <Column>
          <span>
            {t('screens.configuration.components.selectRingTones.callWaiting')}
          </span>
          <span className="text-description">
            {t(
              'screens.configuration.components.selectRingTones.callWaitingSubtitle'
            )}
          </span>
        </Column>
        <BlueSwitch
          checked={systemCallWaitingSound}
          onChange={handleCallWaitingSound}
          name="checkedA"
          inputProps={{ 'aria-label': 'checkbox' }}
        />
      </Row>
      <Row>
        <Column>
          <span>
            {t('screens.configuration.components.sounds.disableKeypadTone')}
          </span>
          <span className="text-description">
            {t(
              'screens.configuration.components.sounds.disableKeypadToneSubTitle'
            )}
          </span>
        </Column>
        <BlueSwitch
          checked={!disableKeypadTone}
          onChange={handleKeypadTone}
          name="checkedA"
          inputProps={{ 'aria-label': 'checkbox' }}
        />
      </Row>
    </Container>
  );
}
